<script>
import LogQueryEditor from '@/components/Log/LogQueryEditor.vue';
import RexButton from '@/rex-components/rex-button.vue';
import RexModalSelect from '@/rex-components/rex-modal-select.vue';
import RexTabsV3 from '@/rex-components/RexTabsV3.vue';
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
import Loading from '@/rex-components/rex-loading.vue';
import { LOGService } from '@/services/api/log.service';
import { mapState, mapMutations, mapGetters } from 'vuex';
import { ALL } from '@/components/Log/log.constants';
import { getRouteName } from '@/components/Log/log.types';

export default {
  components: {
    LogQueryEditor,
    RexButton,
    RexModalSelect,
    Loading,
    RexTabsV3,
    RexSearchSelect,
  },
  computed: {
    ...mapState('globalState/user', ['teamID']),
    ...mapState('logState/logCommonState', ['sourceList', 'isADType']),
    ...mapGetters('logState/logCommonState', [
      'getExecuteSavedSearch',
      'getWidgetFormData',
      'getCapabilityType',
    ]),
    ...mapState('globalState/app', ['openMenu']),
    disableRunBtn() {
      return this.queryStr?.length === 0 || !this.enableRun;
    },
    dispSQLQuery() {
      return this.isSqlQueryVal !== 'false';
    },
    mulitiSelSourceLabel() {
      let sourcesLen =
        this.sourceOptions.filter((obj) => obj.selected).length || 0;
      sourcesLen =
        sourcesLen === this.sourceOptions.length && sourcesLen > 0
          ? sourcesLen - 1
          : sourcesLen;
      const sourceStrKey =
        sourcesLen === 1 ? 'serviceSelected' : 'servicesSelected';

      return sourcesLen === 0
        ? this.$t('log.selectServices')
        : this.$t(`log.${sourceStrKey}`, [sourcesLen]);
    },
    getTabs() {
      return this.isADType
        ? [this.$t('log.ssqlQuery')]
        : [this.$t('log.ssqlQuery'), this.$t('log.freeText')];
    },
    cmEditorWidth() {
      return this.openMenu ? '78.25vw' : '90.25vw';
    },
    editorWidth() {
      return this.openMenu ? '80.5vw' : '92.5vw';
    },
  },
  data() {
    return {
      queryStr: '',
      options: [],
      loading: false,
      queryErrMsg: '',
      enableRun: false,
      isSqlQueryVal: 'true',
      sourceOptions: [],
    };
  },
  methods: {
    ...mapMutations('logState/logCommonState', [
      'setQueryHeaders',
      'setFreeSearchSources',
      'resetExecuteSavedSearch',
      'setWidgetFormData',
      'setQueryEnableSavedSearchType',
      'setExecuteSavedSearch',
    ]),
    ...mapMutations('apmState/trace', ['setCurrentTraceId']),
    clearEditor() {
      this.queryStr = '';
      if (this.$route.query?.queryExec) {
        this.$router.push({
          name: getRouteName(this.isADType),
          query: { ...this.$route.query, queryExec: '', queryFields: '' },
        });
        this.setQueryHeaders([]);
      }
      this.setCurrentTraceId('');
    },
    async runQuery() {
      this.setCurrentTraceId('');
      if (this.queryStr !== this.$route.query?.queryExec) {
        this.$router.push({
          name: getRouteName(this.isADType),
          query: { ...this.$route.query, queryExec: this.queryStr, search: '' },
        });
      }
      this.setFreeSearchSources(
        this.sourceOptions
          .filter((obj) => obj.selected && obj.key !== ALL)
          .map((obj) => obj.key),
      );
      this.setQueryEnableSavedSearchType('');
      if (
        this.dispSQLQuery &&
        this.getExecuteSavedSearch.isAddWidgetWithoutSavedSearch
      ) {
        this.resetExecuteSavedSearch();
        this.setWidgetFormData({
          field: 'isCreateOrUpdateSavedSearch',
          value: true,
        });
      }
      this.enableRun = false;
    },
    async getRecentQueries() {
      try {
        this.loading = true;
        this.options = [];
        this.queryErrMsg = '';

        const { data } = await LOGService.getRecentSqlQuery({
          team_id: this.teamID,
          isSQLQuery: this.dispSQLQuery,
          capability: this.getCapabilityType,
        });

        if (data?.length > 0) {
          this.options = data.map((optn) => ({
            name: optn.query,
            value: optn.query,
            sources: optn.sources || [],
          }));
        } else {
          this.options = [];
          this.queryErrMsg = this.$t('log.thereWereNoQueriesExecuted');
        }
        this.loading = false;
      } catch (error) {
        console.log('error', error);
        this.options = [];
        this.loading = false;
        this.queryErrMsg = this.$t(
          'log.encounteredProblemWhileFetchingQueries',
        );
      }
    },
    onRecentQuerySelect(val, option) {
      this.queryStr = val;
      if (!this.enableRun && !this.getWidgetFormData.isQueryExecuted)
        this.enableRun = true;
      if (this.getWidgetFormData.isQueryExecuted)
        this.setWidgetFormData({ value: false, field: 'isQueryExecuted' });
      if (!this.dispSQLQuery) {
        let enableSelectAll = true;
        this.sourceOptions = this.sourceOptions.map((obj) => {
          if (option.sources.includes(obj.key)) obj.selected = true;
          else obj.selected = false;
          if (obj.key !== ALL)
            enableSelectAll = enableSelectAll && obj.selected;
          return obj;
        });
        this.sourceOptions[0].selected = enableSelectAll;
      }
    },
    showRecentQueries(event) {
      event.target.className === 'recent-queries-field' &&
        this.$refs.recentQueriesSelect.open &&
        this.getRecentQueries();
    },
    onQueryTypeChange(val) {
      if (this.getExecuteSavedSearch?.isTextSearchTypeSelected) {
        this.setExecuteSavedSearch({
          field: 'isTextSearchTypeSelected',
          value: false,
        });
        this.setWidgetFormData({ value: false, field: 'isQueryExecuted' });
        return;
      }
      this.queryStr = '';
      if (this.$route.query?.queryExec) {
        this.$router.push({
          name: getRouteName(this.isADType),
          query: {
            ...this.$route.query,
            queryExec: '',
            queryFields: '',
            isSqlQuery: val === '1',
          },
        });
      } else {
        this.$router.push({
          name: getRouteName(this.isADType),
          query: { ...this.$route.query, isSqlQuery: val === '1' },
        });
      }
    },
    onSourceSelect(item) {
      let selectAllValue = false;
      let enableSelectAll = true;
      this.sourceOptions = this.sourceOptions.map((obj) => {
        if (obj.key === ALL) {
          selectAllValue = item.key === ALL ? !obj.selected : false;
          obj.selected = selectAllValue;
        } else if (item.key === ALL) obj.selected = selectAllValue;
        else if (obj.key === item.key) obj.selected = !obj.selected;

        if (obj.key !== ALL) enableSelectAll = enableSelectAll && obj.selected;
        return obj;
      });
      this.sourceOptions[0].selected = enableSelectAll;
    },
  },
  watch: {
    '$route.query.queryExec': {
      immediate: true,
      handler(newValue) {
        this.enableRun = false;
        if (newValue !== this.queryStr) this.queryStr = newValue;
      },
    },
    '$route.query.isSqlQuery': {
      immediate: true,
      handler(newValue) {
        this.isSqlQueryVal = newValue;
      },
    },
    sourceList: {
      immediate: true,
      handler(newValue) {
        const formattedSources = newValue.map((obj) => ({
          name: obj.name,
          key: obj.value,
          selected: true,
        }));
        this.sourceOptions = [
          { name: this.$t('log.all'), key: ALL, selected: true },
          ...formattedSources,
        ];
        this.setFreeSearchSources(
          this.sourceOptions
            .filter((obj) => obj.selected && obj.key !== ALL)
            .map((obj) => obj.key),
        );
      },
    },
    sourceOptions() {
      this.enableRun = true;
    },
  },
};
</script>

<template>
  <div class="log-editor-container">
    <RexTabsV3
      :tabs="getTabs"
      @onTabChange="onQueryTypeChange"
      :defaultTabIndex="dispSQLQuery ? 0 : 1"
      :updateTabIndex="dispSQLQuery ? 0 : 1"
      :activeKey="dispSQLQuery ? '1' : '2'"
      :destroyInactiveTabPane="true"
    >
      <template #[`tab-${dispSQLQuery?1:2}`]>
        <LogQueryEditor
          :editorValue="queryStr"
          @onTextChange="
            (val) => {
              queryStr = val;
              if (!enableRun && !getWidgetFormData.isQueryExecuted)
                enableRun = true;
              if (getWidgetFormData.isQueryExecuted)
                setWidgetFormData({ value: false, field: 'isQueryExecuted' });
            }
          "
          :editorType="dispSQLQuery ? 'sql' : 'plain_text'"
        />
      </template>
      <template #tab-footer>
        <div class="log-editor-footer">
          <div class="queries-container" @click="showRecentQueries">
            <RexModalSelect
              id="log-recent-queries-select"
              :options="options"
              width="12.5rem"
              ref="recentQueriesSelect"
              @input="onRecentQuerySelect"
            >
              <template #selected-field>
                <div class="recent-queries-field">
                  {{ $t('log.recentQueries') }}
                </div>
              </template>
              <template #before-options>
                <Loading v-if="loading" class="query-loader" />
                <div v-else-if="!!queryErrMsg" class="err-msg-box">
                  {{ queryErrMsg }}
                </div>
              </template>
            </RexModalSelect>
            <RexSearchSelect
              v-if="!dispSQLQuery"
              :isEdit="true"
              :data="sourceOptions"
              width="12.5rem"
              :boldActive="true"
              :isSearch="true"
              :searchPlaceholder="$t('log.searchServices')"
              :multiSelect="true"
              @onMultiSelect="(item) => onSourceSelect(item)"
              :multiSelectTitle="mulitiSelSourceLabel"
              id="log-query-select-sources-field"
              class="select-sources-field"
              :useParentData="true"
            />
          </div>
          <div>
            <RexButton
              variant="secondary"
              id="log-query-editor-clear-btn"
              @onClick="clearEditor"
              class="query-clear-btn"
              :styling="{ width: '4rem' }"
            >
              {{ $t('log.clear') }}
            </RexButton>

            <RexButton
              :variant="disableRunBtn ? 'disabled' : 'primary'"
              id="log-query-editor-run-btn"
              :styling="{ width: '3.75rem' }"
              @onClick="runQuery"
            >
              {{ $t('log.run') }}
            </RexButton>
          </div>
        </div>
      </template>
    </RexTabsV3>
  </div>
</template>

<style lang="scss" scoped>
.log-editor-container {
  border-radius: 0.5rem;
  padding: 0.875rem 1.125rem 0rem 1.125rem;
  margin-bottom: 0.75rem;
  background-color: rgb(26, 26, 26);
  width: v-bind(editorWidth);
}
.log-editor-footer {
  @include flex-center-justify(space-between);
  padding-bottom: 1.125rem;
  margin-top: 1.125rem;
}
.queries-container {
  @include flex-center-vert;
}
.select-sources-field {
  margin-left: 1.75rem;
  text-align: left;
  cursor: pointer;
}
.query-clear-btn {
  @include dropshadow-effect(0);
  border: none;
  margin-right: 1.75rem;
  font-size: 1rem;
}
.recent-queries-field {
  @include flex-center-justify(space-between);
  background-color: transparent;
  color: $font-primary;
  cursor: pointer;
  user-select: none;
  height: 2.5em;
  padding: 0rem 1.063rem 0rem 0.875rem;
}
.recent-queries-field:after {
  content: '';
  border-left: 0.3125rem solid transparent;
  border-right: 0.3125rem solid transparent;
  border-top: 0.3125rem solid $font-primary;
}
.query-loader {
  padding: 1rem 0rem;
}
.err-msg-box {
  margin-left: 0.875rem;
  padding: 1rem 0rem;
  cursor: not-allowed;
  pointer-events: none;
}
:deep(.rex-service-sel) {
  border-radius: 0.188rem;
  background-color: rgb(26, 26, 26);
}
:deep(.items) {
  border-radius: 0.188rem;
  background-color: rgb(26, 26, 26);
  width: 50rem;
  overflow-y: auto;
  margin-top: 0.344rem;
}
:deep(.item-text) {
  white-space: normal;
}
:deep(.loader01) {
  height: 2.375rem !important;
  width: 2.375rem !important;
  border: 0.15rem solid $color-white;
  border-right-color: transparent;
}
:deep(.loader01:after) {
  height: 0 !important;
  width: 0 !important;
}
:deep(.nav-link) {
  margin-left: 19px;
  font-size: 1rem;
}
:deep(.cm-editor) {
  width: v-bind(cmEditorWidth);
}
</style>
